import { z } from "zod";

/**
 * Contact form validation schema
 */
export const contactFormSchema = z.object({
  name: z
    .string()
    .nonempty("Please fill your name")
    .min(2, { error: "Name must be at least 2 characters." }),

  email: z.email("Invalid email address").nonempty("Email is required"),
  message: z
    .string()
    .nonempty("Please fill your message")
    .min(10, { error: "Message must be at least 10 characters." }),
});

export type ContactFormInput = z.infer<typeof contactFormSchema>;
